import React, { useState } from "react";

import FollowCard from "./FollowCard";

import { VoteDateContextProvider } from "contexts/VoteDate";
const Index = props => {
  const SwitchComponents = ({ active, children }) => {
    return children.filter(child => child.props.name === active);
  };
  // Local State
  const [pageProps, setPageProps] = useState({
    active: "FollowCard",
    props: null
  });

  return (
    <VoteDateContextProvider>
      <SwitchComponents active={pageProps.active}>
        <FollowCard
          name="FollowCard"
          pageProps={pageProps}
          setPageProps={setPageProps}
        />
        <></>
      </SwitchComponents>
    </VoteDateContextProvider>
  );
};

export default Index;
